import "core-js/modules/web.dom.iterable";
import axios from "@/util/http"; // /admin/dict/item/page
//字典list

export function fetchList(query) {
  return axios({
    url: "/admin/dict/page",
    method: "get",
    params: query
  });
} //总子项list

export function fetchItemLists(query) {
  return axios({
    url: "admin/dict/item/page",
    method: "get",
    params: query
  });
} //子项list

export function fetchItemList(id) {
  return axios({
    url: "/admin/dict/item/" + id,
    method: "get"
  });
} //

export function addObj(obj) {
  return axios({
    url: "/admin/dict/",
    method: "post",
    data: obj
  });
}
export function addObjItem(obj) {
  return axios({
    url: "/admin/dict/item",
    method: "post",
    data: obj
  });
}
export function getObj(id) {
  return axios({
    url: "/admin/dict/" + id,
    method: "get"
  });
}
export function delObj(id) {
  return axios({
    url: "/admin/dict/" + id,
    method: "delete"
  });
}
export function deleteS(obj) {
  var params = "";
  obj.forEach(function (item) {
    params += "ids=".concat(item, "&");
  });
  return axios({
    url: "/admin/dict/batch",
    method: "delete",
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    data: params
  });
}
export function delObjItem(id) {
  return axios({
    url: "/admin/dict/item/" + id,
    method: "delete"
  });
}
export function delObjItems(obj) {
  var params = "";
  obj.forEach(function (item) {
    params += "ids=".concat(item, "&");
  });
  return axios({
    url: "/admin/dict/item/batch",
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    method: "delete",
    data: params
  });
}
export function putObj(obj) {
  return axios({
    url: "/admin/dict/",
    method: "put",
    data: obj
  });
}
export function putObjItem(obj) {
  return axios({
    url: "/admin/dict/item/",
    method: "put",
    data: obj
  });
} // 功能下拉数据

export function remote(type) {
  return axios({
    url: "/admin/dict/type/" + type,
    method: "get"
  });
}